// @generated by protobuf-ts 2.11.1 with parameter ts_nocheck
// @generated from protobuf file "tracks.proto" (package "tpg", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Health } from "./tracks";
import type { HealthCheckResponse } from "./tracks";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Tracking } from "./tracks";
import type { Empty } from "./google/protobuf/empty";
import type { PongEvent } from "./tracks";
import type { PingRequest } from "./tracks";
import type { SubscribeEvent } from "./tracks";
import type { SubscribeRequest } from "./tracks";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RemoveSubscriptionRequest } from "./tracks";
import type { SubscriptionResponse } from "./tracks";
import type { AddSubscriptionRequest } from "./tracks";
import type { BulkPositionResponse } from "./tracks";
import type { BulkPositionRequest } from "./tracks";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { PositionResponse } from "./tracks";
import type { PositionRequest } from "./tracks";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service tpg.Tracking
 */
export interface ITrackingClient {
    /**
     * @generated from protobuf rpc: TrackPosition
     */
    trackPosition(input: PositionRequest, options?: RpcOptions): UnaryCall<PositionRequest, PositionResponse>;
    /**
     * @generated from protobuf rpc: TrackPositions
     */
    trackPositions(input: BulkPositionRequest, options?: RpcOptions): UnaryCall<BulkPositionRequest, BulkPositionResponse>;
    /**
     * @generated from protobuf rpc: AddSubscription
     */
    addSubscription(input: AddSubscriptionRequest, options?: RpcOptions): UnaryCall<AddSubscriptionRequest, SubscriptionResponse>;
    /**
     * @generated from protobuf rpc: RemoveSubscription
     */
    removeSubscription(input: RemoveSubscriptionRequest, options?: RpcOptions): UnaryCall<RemoveSubscriptionRequest, SubscriptionResponse>;
    /**
     * @generated from protobuf rpc: Subscribe
     */
    subscribe(input: SubscribeRequest, options?: RpcOptions): ServerStreamingCall<SubscribeRequest, PositionResponse>;
    /**
     * @generated from protobuf rpc: SubscribeV2
     */
    subscribeV2(input: SubscribeRequest, options?: RpcOptions): ServerStreamingCall<SubscribeRequest, SubscribeEvent>;
    /**
     * @generated from protobuf rpc: Ping
     */
    ping(input: PingRequest, options?: RpcOptions): UnaryCall<PingRequest, PongEvent>;
    /**
     * @generated from protobuf rpc: Pong
     */
    pong(input: PongEvent, options?: RpcOptions): UnaryCall<PongEvent, Empty>;
}
/**
 * @generated from protobuf service tpg.Tracking
 */
export class TrackingClient implements ITrackingClient, ServiceInfo {
    typeName = Tracking.typeName;
    methods = Tracking.methods;
    options = Tracking.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: TrackPosition
     */
    trackPosition(input: PositionRequest, options?: RpcOptions): UnaryCall<PositionRequest, PositionResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<PositionRequest, PositionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TrackPositions
     */
    trackPositions(input: BulkPositionRequest, options?: RpcOptions): UnaryCall<BulkPositionRequest, BulkPositionResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkPositionRequest, BulkPositionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddSubscription
     */
    addSubscription(input: AddSubscriptionRequest, options?: RpcOptions): UnaryCall<AddSubscriptionRequest, SubscriptionResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddSubscriptionRequest, SubscriptionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveSubscription
     */
    removeSubscription(input: RemoveSubscriptionRequest, options?: RpcOptions): UnaryCall<RemoveSubscriptionRequest, SubscriptionResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveSubscriptionRequest, SubscriptionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Subscribe
     */
    subscribe(input: SubscribeRequest, options?: RpcOptions): ServerStreamingCall<SubscribeRequest, PositionResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubscribeRequest, PositionResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SubscribeV2
     */
    subscribeV2(input: SubscribeRequest, options?: RpcOptions): ServerStreamingCall<SubscribeRequest, SubscribeEvent> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubscribeRequest, SubscribeEvent>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Ping
     */
    ping(input: PingRequest, options?: RpcOptions): UnaryCall<PingRequest, PongEvent> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<PingRequest, PongEvent>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Pong
     */
    pong(input: PongEvent, options?: RpcOptions): UnaryCall<PongEvent, Empty> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<PongEvent, Empty>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service tpg.Health
 */
export interface IHealthClient {
    /**
     * @generated from protobuf rpc: Check
     */
    check(input: Empty, options?: RpcOptions): UnaryCall<Empty, HealthCheckResponse>;
}
/**
 * @generated from protobuf service tpg.Health
 */
export class HealthClient implements IHealthClient, ServiceInfo {
    typeName = Health.typeName;
    methods = Health.methods;
    options = Health.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Check
     */
    check(input: Empty, options?: RpcOptions): UnaryCall<Empty, HealthCheckResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, HealthCheckResponse>("unary", this._transport, method, opt, input);
    }
}
